import bus from 'public/utils/bus'
import store from 'public/store'
import router from '@/layout/router/index'
import { http } from 'public/utils/http'


bus.$once('APP_LOADED', initSdk)

function initSdk () {
  let permission = store.state.permission.menus
  const isAuth = permission && permission.includes('BToQGEG4JmEO')
  if (isAuth) {
    getHotSdk()
  }
}

function getHotSdk () {
  const timestamp = Date.now()
  let permission = store.state.permission.menus
  // 权限控制快捷键打开热力图
  const ctrlPermission = permission && permission.includes('BToT+vfnxx6B')
  const webMonitorHostMap = {
    'www.kye-erp.com': `https://erphostjs.kye-erp.com/kye/kye_bigdata_heatmap.umd.min.js?_=${timestamp}`,
    'edge.uat.kye-erp.com': `https://bigdata-dev-static-code.ky-tech.com.cn/web-monitor/js/kye_bigdata_heatmap.umd.min.js?_=${timestamp}`,
    default: `https://bigdata-dev-static-code.ky-tech.com.cn/web-monitor/js/kye_bigdata_heatmap.umd.min.js?_=${timestamp}`
  }
  return new Promise((resolve) => {
    const url = webMonitorHostMap[location.host] || webMonitorHostMap.default
    const scriptDom = document.createElement('script')
    scriptDom.type = 'text/javascript'
    scriptDom.src = url
    document.body.appendChild(scriptDom)
    scriptDom.onload = function () {
      const installCb = window.kye_bigdata_heatmap && window.kye_bigdata_heatmap.default && window.kye_bigdata_heatmap.default.install
      if (typeof installCb === 'function') {
        installCb({
          useCtrl5OpenPanel: ctrlPermission, // 是否启用 CTRL 五键
          routeInstance: router, // vue 路由实例
          platformHttp: http, // api 请求库实例
          platform: 'erp', // 平台判断
          ignoreElements: () => {
            return [
              document.querySelector('.kye-header-panel'),
              document.querySelector('.kye-aside-panel'),
              document.querySelector('.kye-navbar')
            ]
          },
          dialogNodeIds: [
            'kye_helper_tools_sms',
            'kye_helper_tools_gps_location',
            'kye_helper_tools_car_swing_car',
            'kye_helper_tools_common',
            'kye_helper_tools_calendar',
            'kye_helper_tools_distance',
            'kye_helper_tools_virtual_number',
            'kye_kts_work_order_plugin',
            'kye_tool_auth_apply',
            'kye_check_rules_box',
            'kye-custom-filter-dialog',
            'kye-custom-filter-group',
            'kye-query-table-dialog-drag'
          ],
        })
      }

      resolve()
    }
    scriptDom.onerror = function () {
      resolve()
    }
  })
}




// WEBPACK FOOTER //
// ./src/layout/layout/setup/hot-map.js